import React from "react";
import { ActionNames } from "tng-address-collection-shared/actionNames.ts";

interface DetailClickCellProps {
  handleClick: () => void;
  value: React.ReactNode;
  userHasAction: (actionName: string) => boolean;
  pointer?: boolean;
}

const DetailClickCell = ({
  handleClick: handleDetailClick,
  value,
  userHasAction,
  pointer = true,
}: DetailClickCellProps) =>
  userHasAction(ActionNames.editCard) ? (
    <div
      onClick={handleDetailClick}
      style={pointer ? { cursor: "pointer" } : {}}
    >
      {value ?? "-"}
    </div>
  ) : (
    <div>{value ?? "-"}</div>
  );

export const MemoDetailClickCell = React.memo(DetailClickCell);
